import React from 'react'

import Icon from '@/legacy-src/components/icons/Icon'

type Props = { items: string[]; iconName: string }

const ListWithIcon: React.FC<Props> = ({ items, iconName }) => {
  return (
    <>
      {items.map((item: string, index) => (
        <div
          className="relative flex py-3 after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:w-full after:bg-[url(/images/svg/styleElements/dots2-horizontal.svg)] after:bg-repeat-x after:content-[''] last:after:hidden"
          key={index}
        >
          <Icon className="mr-8" icon={iconName} size="md" />
          <div className="text-base">{item}</div>
        </div>
      ))}
    </>
  )
}

export default ListWithIcon
